document.addEventListener("DOMContentLoaded", (event) => {
  const targetNode = document.getElementById("t4s-mini_cart");
  const config = { attributes: true, childList: true, subtree: true };
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class" &&
        mutation.target.className.includes("t4s-child-lazyloaded")
      ) {
        BSS_B2B.observer.cartSubject.notifyObserver("CartUpdate", "CartMutate");
        (async function () {
          if (BSS_B2B) {
            const res = await BSS_B2B.storage.productStorage.load();
            if (res) {
              if (
                res.notExistProductIds?.length ||
                res.productIds?.length ||
                res.variantIds?.size
              ) {
                BSS_B2B.observer.productSubject.notifyObserver(
                  "LazyProduct",
                  "LoadedLazyProduct",
                  {
                    ...res,
                  }
                );
              }
            }
          }
        })();
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
});
